/**
 * Shared subject-builder catalog: the click-together prompt fields offered on
 * BOTH generation surfaces — the plain text-to-image panel and v2 plugin forms
 * that declare `subject_builder: true`. One definition, two consumers.
 *
 * Every option's `value` is a self-contained prompt phrase; fragments are
 * joined with ", " in field order, so plain concatenation reads naturally.
 * Fields are optional — untouched fields contribute nothing.
 */

export const SUBJECT_BUILDER_FIELDS = [
  {
    id: "age",
    label: "Age",
    options: [
      { value: "18 years old", label: "18" },
      { value: "in her early twenties", label: "Early 20s" },
      { value: "in her late twenties", label: "Late 20s" },
      { value: "in her thirties", label: "30s" },
      { value: "in her forties", label: "40s" },
      { value: "mature, fifty plus", label: "50+" },
    ],
  },
  {
    id: "subject",
    label: "Subject",
    options: [
      { value: "a young woman", label: "Woman" },
      { value: "a man", label: "Man" },
      { value: "a couple (man and woman)", label: "Couple M/F" },
      { value: "two women", label: "Couple F/F" },
      { value: "a group of people", label: "Group" },
    ],
  },
  {
    id: "ethnicity",
    label: "Ethnicity",
    options: [
      { value: "white european look", label: "European" },
      { value: "latina look", label: "Latina" },
      { value: "asian look", label: "Asian" },
      { value: "black african look", label: "African" },
      { value: "middle eastern look", label: "Middle Eastern" },
      { value: "indian look", label: "Indian" },
    ],
  },
  {
    id: "hairColor",
    label: "Hair color",
    options: [
      { value: "blonde hair", label: "Blonde" },
      { value: "brunette hair", label: "Brunette" },
      { value: "red hair", label: "Redhead" },
      { value: "black hair", label: "Black" },
      { value: "platinum blonde hair", label: "Platinum" },
      { value: "brightly dyed hair", label: "Dyed" },
    ],
  },
  {
    id: "hairStyle",
    label: "Hair style",
    options: [
      { value: "long straight hair", label: "Long straight" },
      { value: "wavy hair", label: "Wavy" },
      { value: "curly hair", label: "Curly" },
      { value: "hair in a ponytail", label: "Ponytail" },
      { value: "hair in a messy bun", label: "Bun" },
      { value: "short pixie cut", label: "Pixie" },
    ],
  },
  {
    id: "body",
    label: "Body type",
    options: [
      { value: "slim body", label: "Slim" },
      { value: "athletic toned body", label: "Athletic" },
      { value: "curvy figure", label: "Curvy" },
      { value: "petite body", label: "Petite" },
      { value: "full figured body", label: "Full figured" },
      { value: "muscular body", label: "Muscular" },
    ],
  },
  {
    id: "outfit",
    label: "Outfit",
    options: [
      { value: "wearing a bikini", label: "Bikini" },
      { value: "wearing casual clothes", label: "Casual" },
      { value: "wearing office attire", label: "Office" },
      { value: "wearing a tight dress", label: "Dress" },
    ],
  },
  {
    id: "setting",
    label: "Setting / light",
    options: [
      { value: "in a bedroom", label: "Bedroom" },
      { value: "in a bathroom", label: "Bathroom" },
      { value: "under a warm shower", label: "Shower" },
      { value: "on a beach at sunset", label: "Beach" },
      { value: "by a pool", label: "Pool" },
      { value: "in a hotel room", label: "Hotel" },
      { value: "studio backdrop, soft window light", label: "Studio" },
      { value: "neon lit night scene", label: "Neon" },
    ],
  },
];

/**
 * Compose the selected fragments into one subject string.
 * selections: { [fieldId]: optionValue }. Returns "" when nothing is picked.
 */
export function composeSubject(selections) {
  return SUBJECT_BUILDER_FIELDS.map((f) => selections[f.id])
    .filter(Boolean)
    .join(", ");
}
